<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加五折申购</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="新建项目"
      width="1000px"
      @close="closeDialog"
    >
      <el-form :model="detail" ref="form" :rules="rules" label-width="140px">
        <el-form-item label="申购币种：" prop="coinType">
          <el-select v-model="detail.coinType" placeholder="请选择">
            <el-option
              v-for="item in coinTypeList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="总量：" prop="totalAmount">
          <el-input-number
            v-model="detail.totalAmount"
            :min="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="最小申购数量：" prop="minAmount">
          <el-input-number
            v-model="detail.minAmount"
            :min="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="最大申购数量：" prop="maxAmount">
          <el-input-number
            v-model="detail.maxAmount"
            :min="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="最大申购数量精度：" prop="precisions">
          <el-input-number
            v-model="detail.precisions"
            :min="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="官网地址：" prop="officialUrl">
          <el-input v-model="detail.officialUrl"></el-input>
        </el-form-item>
        <el-form-item label="白皮书地址：" prop="whiteUrl">
          <el-input v-model="detail.whiteUrl"></el-input>
        </el-form-item>
        <el-form-item label="起止时间：" required>
          <el-col :span="7">
            <el-form-item prop="startTime">
              <el-date-picker
                v-model="detail.startTime"
                value-format="timestamp"
                type="datetime"
                placeholder="选择开始时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item prop="endTime">
              <el-date-picker
                v-model="detail.endTime"
                value-format="timestamp"
                type="datetime"
                placeholder="选择截止时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="支持币种：" prop="supportCoin">
          <div class="three-coin">
            <el-input
              v-model="detail.supportCoin[0].coin"
              class="disinput"
              disabled="disabled"
            ></el-input>
            <el-input-number
              v-model="detail.supportCoin[0].price"
              :min="0"
            ></el-input-number>
            <el-input
              v-model="detail.supportCoin[0].cof"
              class="disinputs"
              disabled="disabled"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="币种图标(png)：" prop="listImageUrl">
          <upload
            v-model="detail.signUrl"
            :data="{ category: 'purchase' }"
          ></upload>
        </el-form-item>
        <el-form-item label="详情页横幅图片：" prop="bannerUrl">
          <upload
            v-model="detail.bannerUrl"
            :data="{ category: 'purchase' }"
          ></upload>
        </el-form-item>
        <el-form-item label="列表页缩略图片：" prop="listImageUrl">
          <upload
            v-model="detail.listImageUrl"
            :data="{ category: 'purchase' }"
          ></upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Editor from 'components/editor';
import Upload from 'components/upload';
import LANGUAGE from 'common/languages';
import MutipleInput from '../mutipleInput';

export default {
  name: 'purchaseCreate',
  data() {
    const validateEndTime = (rule, value, callback) => {
      if (!this.detail.endTime) {
        callback(new Error('请填写'));
      }
      if (
        this.detail.startTime &&
        this.detail.endTime &&
        value < this.detail.startTime
      )
        callback(new Error('截止时间不得早于开始时间'));
      callback();
    };
    const validateStartTime = (rule, value, callback) => {
      if (!this.detail.startTime) {
        callback(new Error('请填写'));
      }
      if (this.detail.startTime < new Date())
        callback(new Error('开始时间不得早于当前时间'));
      callback();
    };
    return {
      dialogVisible: false,
      detail: {
        supportCoin: [
          {
            coin: 'FBS',
            price: '',
            cof: 1
          }
        ],
        type: 1
      },
      rules: {
        coinType: {
          required: true,
          message: '请填写'
        },
        totalAmount: {
          required: true,
          message: '请填写'
        },
        minAmount: {
          required: true,
          message: '请填写'
        },
        maxAmount: {
          required: true,
          message: '请填写'
        },
        totalAmount: {
          required: true,
          message: '请填写'
        },
        startTime: [
          {
            validator: validateStartTime,
            trigger: 'change'
          }
        ],
        endTime: [
          {
            validator: validateEndTime,
            trigger: 'change'
          }
        ],
        supportCoin: {
          required: true,
          message: '请填写'
        },
        signUrl: {
          required: true,
          message: '请填写'
        },
        bannerUrl: {
          required: true,
          message: '请填写'
        },
        listImageUrl: {
          required: true,
          message: '请填写'
        }
      }
    };
  },
  components: {
    Editor,
    Upload,
    MutipleInput
  },
  computed: {
    ...mapState('discount', ['coinTypeList', 'languageList'])
  },
  methods: {
    ...mapActions('discount', ['create']),
    closeDialog() {
      this.dialogVisible = false;
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      this.create(this.detail).then(() => {
        this.$message({
          message: '添加成功！',
          type: 'success'
        });
        this.dialogVisible = false;
        this.$emit('refresh', {
          page: 1
        });
      });
    }
  }
};
</script>

<style lang="less">
.editor {
  height: 500px;
}
.three-coin {
  display: flex;
  justify-content: flex-start;
  .disinput {
    width: 200px;
    margin-right: 20px;
  }
  .disinputs {
    width: 200px;
    margin-left: 20px;
  }
}
</style>
